<template>
  <div class="printPage" id="printPage" v-loading="loading">
    <div class="print-title">
      <img src="@/assets/img/common/logo.png"/>
    </div>
    <div class="print-header">
      评价委托书正文
    </div>
    <div class="print-body">
      <h3>易派客产品质量评价工作委托单(NO:{{info.noticeNo}})</h3>
      <p class="print-name">{{info.agencyCompanyName}}：</p>
      <p class="print-content">
        现委托贵单位按照{{info.evaluationCode}}评价标准，对{{info.companyName}}所申请的申请单号{{info.applyCode}}开展质量评价工作。
      </p>
      <p class="print-content">
        主要工作内容包括（但不限于）现场审查，产品抽样，产品性能测试，出具评价报告和质量分级结论。评价报告自接到委托后，按照供应商申请先后顺序在20个工作日内完成。
      </p>
      <div class="print-sign">
        <div>易派客电子商务有限公司</div>
        <div>{{info.noticeTime}}</div>
      </div>
    </div>
    <div class="print-btn no-print" v-if="isShowExport">
      <eui-btn type="secondary" @click="handleClose">返 回</eui-btn>
      <div>
        <eui-btn type="secondary" @click="handlePrint">打印</eui-btn>
        <eui-btn type="primary" @click="handleExportPdf">导出PDF</eui-btn>
      </div>
    </div>
  </div>
</template>

<script>
import Api from '@/modules/projectA/api/ESorganization';

export default {
  name: 'commissionSheet',
  data() {
    return {
      isShowExport: true,
      logo: require('@/assets/img/common/epec.png'),
      info: {
        agencyCompanyName: '',
        applyCode: '',
        companyName: '',
        evaluationCode: '',
        noticeNo: '',
        noticeTime: ''
      },
      loading: false
    };
  },
  created() {
    this.loading = true;
    Api.queryApplyCommission({ applyId: this.$route.query.applyId })
      .then(res => {
        if (res.code === '200') {
          this.info = res.data;
        }
        this.loading = false;
      });
  },
  methods: {
    handlePrint() {
      window.print();
    },
    handleClose() {
      window.close();
    },
    handleExportPdf() {
      this.isShowExport = false;
      this.$nextTick(() => {
        this.getPdf('printPage', `易派客产品质量评价工作委托单(NO:${this.info.noticeNo})`, () => {
          this.isShowExport = true;
        });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
  @import '@/assets/css/theme.scss';

  @media print {
    /* 打印时不需要显示的元素 */
    .no-print {
      display: none !important;
    }
    .printPage {
      margin: 20px 20px 0 !important;
      transform: scale(0.63) !important;
      transform-origin: left top !important;
      -webkit-print-color-adjust: exact;
      -moz-print-color-adjust: exact;
      -ms-print-color-adjust: exact;
      print-color-adjust: exact;
    }
    .calendar {
      /* 隐藏日历页面中不需要打印的元素 */
      display: none;
    }
  }

  .printPage {
    width: 1200px;
    max-height: 800px;
    margin: 0 auto;
    padding-bottom: 30px;
    background: url("~@/assets/img/common/bk-epk.png") repeat;
    font-family: Source Han Sans CN;
  }

  .print-title {
    padding: 20px;

    img {
      width: 218px;
      height: 54px;
      vertical-align: top;
    }
  }

  .print-header {
    width: 1160px;
    margin: 0 auto;
    padding-left: 20px;
    height: 40px;
    line-height: 40px;
    color: #ffffff;
    background: $main-col;
  }

  .print-body {
    width: 1160px;
    min-height: 418px;
    margin: 0 auto;
    padding: 30px 20px 20px;
    border: 1px solid #D9D9D9;
    border-top: 0;

    > h3 {
      margin-bottom: 30px;
      font-size: 20px;
      line-height: 1;
      text-align: center;
      font-weight: normal;
    }

    > .print-name {
      margin-bottom: 20px;
      font-size: 16px;
      line-height: 1;
    }

    .print-content {
      text-indent: 2em;
      font-size: 16px;
      line-height: 21px;
      text-align: justify;
    }
  }

  .print-sign {
    margin-top: 176px;
    text-align: right;
  }

  .print-btn {
    padding: 20px 20px 0;
    display: flex;
    justify-content: space-between;
  }
</style>
<style>
  @media print {
    html, body, #app, .wrapper {
      height: auto !important;
    }
  }
</style>
